import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { FaStar, FaRegStar } from "react-icons/fa"; // Import Star Icons
import url from "../../function/url";
import EmployeeNavbar from "../Employees/EmployeeNavbar";
import "../company/formstyle.css";
import Swal from "sweetalert2";
import "./rating.css";

const RatingsList = () => {
  const [ratings, setRatings] = useState([]);
  const ID = Cookies.get("log_id");
  const [totalRating, setTotalRating] = useState(0); // State to hold the total rating

  useEffect(() => {
    const fetchRatings = async () => {
      if (!ID) {
        Swal.fire("Error", "Login ID not found. Please log in again.", "error");
        return;
      }
      try {
        const response = await axios.get(`${url.path}/my-ratings/${ID}/`);
        if (response.data.status) {
          setRatings(response.data.ratings);
          setTotalRating(response.data.total_rating); // Set the total rating from the response

        } else {
          Swal.fire("Error", response.data.message, "error");
        }
      } catch (error) {
        console.error("Error fetching ratings:", error);
        Swal.fire(
          "Error",
          error.response?.data?.message || "Failed to fetch ratings. Try again later.",
          "error"
        );
      }
    };
    fetchRatings();
  }, [ID]);

  // Function to render stars based on rating value
  const renderStars = (rating) => {
    const maxStars = 5; // Set max stars to 5
    return (
      <div className="stars">
        {[...Array(maxStars)].map((_, index) => (
          index < rating ? <FaStar key={index} className="star filled" /> : <FaRegStar key={index} className="star" />
        ))}
      </div>
    );
  };
  

  return (
    <>
      <EmployeeNavbar />
      <div className="page-wrapper">
        <div className="form-container">
        <div id="ndiv">
                    <h1 style={{fontSize:'30px'}}>Rating</h1>
                </div>
                Total Rating: {totalRating}  {renderStars(totalRating)}
          {ratings.length > 0 ? (
            <table className="ratings-table">
              <thead>
                <tr>
                  <th>Rating Factor</th>
                  <th>Description</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                {ratings.map((rating) => (
                  <tr key={rating.id}>
                    <td>{rating.rating_factor?.rating_factor || "N/A"}</td>
                    <td>{rating.rating_factor?.description || "No description available"}</td>
                    <td>{rating.value}</td>
                  </tr>
                  
                ))}
              </tbody>
            </table>
              ) : (
                <p>No ratings available.</p>
              )}
          
        </div>
      </div>
    </>
  );
};

export default RatingsList;
